<div
  #container
>
  <label  class="form-label "
          *ngIf="label"
          [for]="name"
  >{{ label }}
  </label>

  <div >
    <div class="input-group"  >

      <input
        *ngIf="type === 'text'"
        [id]="name"
        class="form-control"
        [value]="value"
        type="text"
        [tabindex]="tabindex"
        [class.form-control-sm]="small"
        [class.text-end]="valueAlign === 'end'"
        readonly
        [placeholder]="placeholder"
        disabled
      >

      <textarea
        *ngIf="type === 'textarea'"
        [id]="name"
        class="form-control"
        [value]="value"
        type="text"
        [tabindex]="tabindex"
        [class.form-control-sm]="small"
        [class.text-end]="valueAlign === 'end'"
        autosize
        readonly
        [placeholder]="placeholder"
        disabled
        [minRows]="minRows"
      ></textarea>

      <button *ngIf="link" class="btn btn-outline-secondary" [routerLink]="link" type="button">
        <i class="fa fa-link"></i>
      </button>
    </div>
  </div>
</div>
